import React from "react";

import { Button, Form, Input } from "antd";

import { useTranslation } from "react-i18next";

import slice from "../../reducer";

import {
  makeSelectBaseCompanyCurrency,
  makeSelectTransportCharacteristics,
  makeSelectUserInfo,
} from "../../../../containers/App/selectors";

import { useDispatch, useSelector } from "react-redux";

type FormInput = {
  transportCharacteristicId: number;
  currencyId: number;
  companyId: number;
};

const FwlForm = React.memo(() => {
  const { t } = useTranslation("translations");

  const dispatch = useDispatch();

  const baseCompanyCurrency = useSelector(makeSelectBaseCompanyCurrency());

  const transportCharacteristics = useSelector(makeSelectTransportCharacteristics());
  const transportCharacteristic = transportCharacteristics.find((x) => x.loadType === "FWL")!;

  const userInfo = useSelector(makeSelectUserInfo());

  const handleFinish = (model: FormInput) => {
    dispatch(slice.actions.createApplication(model));
  };

  return (
    <Form
      onFinish={handleFinish}
      initialValues={{
        transportCharacteristicId: transportCharacteristic.id,
        currencyId: baseCompanyCurrency.id,
        companyId: userInfo.company.id,
      }}
    >
      <Form.Item name="transportCharacteristicId" noStyle>
        <Input hidden />
      </Form.Item>
      <Form.Item name="companyId" noStyle>
        <Input hidden />
      </Form.Item>
      <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
        {t("calculate")}
      </Button>
    </Form>
  );
});

export default FwlForm;
